module.exports = __webpack_public_path__ + "static/media/class_photo_gradient.a395bfa0.png";